import { Form } from "react-bootstrap"
import { Box } from "@mui/material"

const SelectInput = (props) => {
  const { value = '', valueName = '', name, label, register, errors, data } = props

  return (
    <Box>
      <Form.Label htmlFor={name}>{label}</Form.Label>
      <Form.Select
        id={name}
        name={name}
        defaultValue={''}
        className={'form-control mb-3' + (errors ? ' border border-danger' : '')}
        {...register(name)}
      >
        <option value={value} disabled={value === '' && valueName === ''}>
          {value !== '' && valueName !== '' ? valueName : 'Seleccionar'}
        </option>
        {data
          ? data.map((curr, i) => {
            if (curr.id !== value) {
              return (
                <option key={curr.id} value={curr.id} className="text-capitalize">
                  {curr.name}
                </option>
              )
            }
          }
          )
          : null}
      </Form.Select>
      {errors && (<p className="text-danger mb-0 mt-2">{errors?.message}</p>)}
    </Box>
  )
}

export default SelectInput